export const cards = [
  {
    copy: 'Your sample arrives at our lab, where DNA is extracted and checked for quality and automatically accessioned using your kit registration details.',
  },
  {
    copy: 'The DNA methylation is then measured at thousands of CpG sites across your genome and the results are securely transferred and stored.',
  },
  {
    copy: 'We then preprocess your raw methylation data and use our TallyAge™ clock to computationally com-bine thousands of your methylation measurements into an accurate estimate of your epigenetic age.',
  },
  {
    copy: 'Next, we compare your lifestyle survey results and TallyAge™ to those of your cohort, to estimate the most impactful lifestyle changes for you, and prepare Action Plans that are tailored to produce the most impact at various levels of intensity.',
  },
  {
    copy: 'Your TallyAge™, tailored recommendations, and additional resources are available for you to review.',
  },
] as {copy: React.ReactNode; image?: string}[];
